<template>

	<component :is="el" @click.prevent="scrollToAnchor(to)"><slot></slot></component>

</template>

<script>

	const AnchorLink = {
		name: "anchorLink",
		props: {
			el: {
				type: String,
				default: "button"
			},
			to: String
		},
		inject: [ "scrollToAnchor" ]
	}

	export default AnchorLink

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AnchorNav/AnchorLink.vue